/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_TitleInputs */

const en_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Markers`)
};

const fr_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les marqueurs`)
};

const de_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportmarkierungen`)
};

const it_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta marcatori`)
};

const ru_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспортные маркеры`)
};

const es_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de exportación`)
};

const zh_cn2_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口标记`)
};

const ja_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートマーカー`)
};

const hi_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात मार्कर`)
};

const pt_pt2_markers_export_title = /** @type {(inputs: Markers_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de exportação`)
};

/**
* | output |
* | --- |
* | "Export Markers" |
*
* @param {Markers_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_title = /** @type {((inputs?: Markers_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_title(inputs)
	if (locale === "de") return de_markers_export_title(inputs)
	if (locale === "it") return it_markers_export_title(inputs)
	if (locale === "ru") return ru_markers_export_title(inputs)
	if (locale === "es") return es_markers_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_title(inputs)
	if (locale === "ja") return ja_markers_export_title(inputs)
	if (locale === "hi") return hi_markers_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_title(inputs)
	return en_markers_export_title(inputs)
});